import {
  MOBILE_HEADER_WITH_GAP_HEIGHT,
  SMALL_DESKTOP_SIZE_BREAKPOINT
} from 'consts'
import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { AiContentLoading } from '../AiImageContent/components/AiContentLoading'
import { COLORS } from 'consts/colors'

export const AIVideoContentContainer = styled.div<{
  $hasSelectedItem?: boolean
}>`
  padding: ${({ $hasSelectedItem }) => ($hasSelectedItem ? '24px' : '0')} 16px 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-y: scroll;
    overflow-x: hidden;
  }
`
export const AIVideoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  flex: 1;
  padding-right: 14px;
  box-sizing: content-box;
  overflow-y: auto;
  overflow-x: hidden;

  ${customizeVerticalScrollbarThumbMixin()}
`
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_WITH_GAP_HEIGHT}px);
    overflow-y: auto;
  }
`

export const AiContentLoadingWrapper = styled(AiContentLoading)`
  margin: 20px 0;
`

export const StickyTabbarWrapper = styled.div`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    position: sticky;
    top: 0;
    z-index: 10;
    background: ${COLORS.white};
    margin: 0 -16px;
    padding: 0 16px;
  }
`
